import { Typography } from '@mui/material';
import GlobalSearcher, { Filter } from 'lib/common/GlobalSearcher';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getFactoringRequestsReceived,
  getRecieverFactoringRequest,
} from '../../../../../../../lib/api';
import { getCompanyConfig } from '../../../../../../../lib/api/company';
import CustomAlert from '../../../../../../../lib/designSystem/Alert';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../../../lib/designSystem/HeaderWithActions';
import {
  showAlert,
  validateCompanyTypes,
  validatePermissions,
} from '../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../services/redux/authSlice';
import ShoppingCartFactoring from '../../../../../../BusinessProfile/SII/Components/BusinessInvoices/components/ShoppingCart';
import DocumentSelector from '../../../common/documentsSelector';
import MyRequestsToApprove from './components/MyRequestsToApprove';
import ShoppingDialogRecieved from './components/ShoppingDialog';

export interface FactoringRequest {
  id: number;
  status: string;
  sender: string;
  recipient: string;
  validUntil: Date;
  paymentDate: Date;
  amount: number;
  extraData: boolean;
  relation?: any;
  businessId: number;
  businessIdentifier: string;
  businessName: string;
}

const dataHeadersDefault = [
  { key: 'id', label: 'ID', type: 'numeric-id' },
  { key: 'exception', label: 'Exc', type: 'boolean-exception-null' },
  { key: 'turn', label: 'Turno', type: 'turn' },
  { key: 'businessName', label: 'Cliente' },
  { key: 'amount', label: 'Monto', type: 'money' },
  { key: 'income', label: 'Ingreso', type: 'good-money' },
  { key: 'minutesSinceUpdate', label: 'Estancado', type: 'formatMinutes' },
  { key: 'operationDate', label: 'Fecha de operación', type: 'date' },
  { key: 'status', label: 'Estado', type: 'status-chip' },
  { key: 'createdAt', label: 'Creado en', type: 'date-large' },
];

const FactoringRequestsRecieved = (props: any) => {
  const { businessIdentifierProp } = props;
  const dispatch = useDispatch();
  const [factoringRequests, setFactoringRequests] = useState<
    FactoringRequest[]
  >([]);
  const [exchangeDay, setExchangeDay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [miniLoading, setMiniLoading] = useState(false);
  const [shoppingCartType, setShoppingCartType] = useState('');
  const [openShoppingCart, setOpenShoppingCart] = useState(false);
  const [openRequest, setOpenRequest] = useState<FactoringRequest | null>(null);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [successText, setSuccesText] = useState('');
  const [failedMessage, setFailedText] = useState('');
  const [dataHeaders, setDataHeaders] = useState<any>(dataHeadersDefault);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [openDocumentsSelector, setOpenDocumentsSelector] = useState(false);
  const [openNewShoppingCart, setNewOpenShoppingCart] = useState(false);
  const [continueToSimulation, setContinueToSimulation] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<any>({});
  const [business, setBusiness] = useState<any>({});
  const [subProductSelected, setSubProductSelected] = useState<any>(null);
  const [subProduct, setSubProduct] = useState<any>(null);
  const [backwards, setBackwards] = useState(false);
  const newOperationDate = new Date();
  // Set to 12:00:00
  newOperationDate.setUTCHours(12);
  const [operationDate, setOperationDate] = useState(newOperationDate);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [openMyRequestsToApprove, setOpenMyRequestsToApprove] = useState(false);

  const handleNewRequest = () => {
    const actualOperationDate = new Date();
    actualOperationDate.setUTCHours(12);
    setOperationDate(actualOperationDate);
    setOpenDocumentsSelector(true);
  };
  // Search
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchClient, setSearchClient] = useState('');
  const [requestId, setRequestId] = useState('');
  const [searchExecutive, setSearchExecutive] = useState('');
  const [searchRequestId, setSearchRequestId] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [searchStatuses, setSearchStatuses] = useState<any[]>([
    { label: 'Creada', value: 'CREATED' },
    { label: 'En revisión', value: 'IN_REVIEW' },
    { label: 'Aceptada', value: 'ACCEPTED' },
    { label: 'En giro', value: 'IN_TRANSFER' },
  ]);

  const [draftEnabled, setDraftEnabled] = useState(false);

  const PAGE = 1;
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: PAGE,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });

  const generateQuery = (page: number, pageSize: number) => {
    let query = '';
    if (page) query += `page=${page}&`;
    if (pageSize) query += `pageSize=${pageSize}&`;
    if (searchClient) query += `businessIdentifier=${searchClient}&`;
    if (businessIdentifierProp)
      query += `businessIdentifier=${businessIdentifierProp}&`;
    if (startDate) query += `startDate=${startDate}&`;
    if (endDate) query += `endDate=${endDate}&`;
    if (businessName)
      query += `businessName=${businessName.replace('&', '%26')}&`;
    if (searchRequestId) query += `id=${searchRequestId}&`;
    if (requestId) query += `requestId=${requestId}&`;
    if (searchExecutive) query += `executiveName=${searchExecutive}&`;
    if (searchStatuses.length > 0) {
      let stringForQuery = '';
      for (const status of searchStatuses) {
        stringForQuery += `${status.value},`;
      }
      stringForQuery = stringForQuery.slice(0, -1);
      query += `statuses=${stringForQuery}&`;
    }
    return query;
  };

  const setSuccessOpen = (text: string) => {
    setSuccess(true);
    setSuccesText(text);
  };

  const setFailureOpen = (text: string) => {
    setFailed(true);
    setFailedText(text);
  };

  const handleDetails = async (id: number) => {
    setMiniLoading(true);
    try {
      const request = await getRecieverFactoringRequest(dispatch, {
        requestId: id,
      });
      setSelectedId(id);
      setOperationDate(new Date(request.requestDate));
      setOpenRequest(request);
      setMiniLoading(false);
      setShoppingCartType(request.status);
      setOpenShoppingCart(true);
    } catch (error) {
      setMiniLoading(false);
      return alert('error');
    }
  };

  const resetRequestToOriginal = () => {
    setOpenShoppingCart(false);
    void handleDetails(selectedId);
  };

  const resetShoppingCart = () => {
    if (continueToSimulation) {
      setContinueToSimulation(false);
      setContinueToSimulation(true);
    } else {
      setOpenShoppingCart(false);
      setOpenShoppingCart(true);
    }
  };

  const getFactoringRequests = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    const query = generateQuery(page, pageSize);
    const response = await getFactoringRequestsReceived(dispatch, query);
    setFactoringRequests(response.data);
    setPagination(response.pagination);
    return response;
  };

  const triggerSearch = async () => {
    setLoading(true);
    const response = await getFactoringRequests({
      page: pagination.page,
      pageSize: pagination.pageSize,
    });
    setLoading(false);
    return response;
  };

  const setDataheadersByPermissions = () => {
    if (validatePermissions(user, 'businesses_read_all')) {
      if (
        dataHeadersDefault.find((x) => x.key === 'recipientName') === undefined
      ) {
        dataHeadersDefault.push({ key: 'recipientName', label: 'Ejecutivo' });
      }
      if (dataHeadersDefault.find((x) => x.key === 'createdBy') === undefined) {
        dataHeadersDefault.push({ key: 'createdBy', label: 'Creado por' });
      }
    }
    setDataHeaders(dataHeadersDefault);
  };

  const setUp = async (id?: number) => {
    setLoading(true);
    try {
      setDataheadersByPermissions();
      setOpenShoppingCart(false);
      const response = await getFactoringRequests({
        page: pagination.page,
        pageSize: pagination.pageSize,
      });
      if (id) {
        void handleDetails(id);
      }
      setLoading(false);
      return response;
    } catch (error) {
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (draftEnabled) {
      void setUp();
    }
  }, [draftEnabled]);

  const fetchDraftEnabled = async () => {
    setLoading(true);
    try {
      const draftEnabledResponse = await getCompanyConfig(
        dispatch,
        'system_operations_enable_draft_status',
      );
      const draftEnabled = draftEnabledResponse === '1';
      if (!draftEnabled) {
        void setUp();
      }
      if (draftEnabled) {
        setSearchStatuses([
          ...searchStatuses,
          { label: 'Borrador', value: 'DRAFT' },
        ]);
      }
      setDraftEnabled(draftEnabled);
    } catch (error) {
      console.error(error);
      void setUp();
    }
  };

  useEffect(() => {
    void fetchDraftEnabled();
  }, []);

  const handleToSimulation = async () => {
    setLoading(true);
    try {
      setContinueToSimulation(true);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const filters: Filter[] = [
    {
      type: 'multiple',
      label: 'Estado',
      value: searchStatuses,
      setter: setSearchStatuses,
      options: [
        { label: 'Creada', value: 'CREATED' },
        { label: 'En revisión', value: 'IN_REVIEW' },
        { label: 'Aceptada', value: 'ACCEPTED' },
        { label: 'Rechazada', value: 'REJECTED' },
        { label: 'En giro', value: 'IN_TRANSFER' },
        { label: 'Activa', value: 'ACTIVE' },
        { label: 'Completada', value: 'COMPLETED' },
        ...(draftEnabled ? [{ label: 'Borrador', value: 'DRAFT' }] : []),
      ],
    },
    {
      label: 'Fecha de operación',
      type: 'date',
      value: startDate,
      setter: setStartDate,
      dateKey: 'startDate',
    },
    {
      label: 'Fecha de operación',
      type: 'date',
      value: endDate,
      setter: setEndDate,
      dateKey: 'endDate',
    },
    {
      label: 'Nombre cliente',
      type: 'autocomplete',
      value: businessName,
      key: 'businessName',
      setter: setBusinessName,
    },
    {
      label: 'ID de solicitud',
      type: 'text',
      value: requestId,
      setter: setRequestId,
      specialHandler: 'id',
    },
    {
      label: 'Rut cliente',
      type: 'text',
      value: searchClient,
      setter: setSearchClient,
    },
    {
      label: 'Ejecutivo',
      type: 'autocomplete',
      value: searchExecutive,
      key: 'userName',
      setter: setSearchExecutive,
    },
  ];

  const buttonsData: CustomButtonProps[] = [
    {
      name: 'Buscar',
      action: () => {},
      color: 'primary',
      customButton: (
        <GlobalSearcher
          filters={filters}
          triggerSearch={triggerSearch}
          dispatch={dispatch}
          disableSearch={loading}
        />
      ),
    },
    {
      action: handleNewRequest,
      name: 'Crear',
      color: 'primary',
      disabled: !validatePermissions(user, 'financing_factoring_create'),
    },
  ];

  if (loading) return <CenteredCircularProgress />;

  const title = businessIdentifierProp
    ? 'Solicitudes'
    : 'Acá podrás ver todas tus solicitudes de factoring';

  const titleVariant = businessIdentifierProp ? 'h6' : 'body1';

  return (
    <div>
      <HeaderWithActions
        customTitle={
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Typography variant={titleVariant}>{title}</Typography>
            {!businessIdentifierProp && (
              <Typography
                onClick={() => setOpenMyRequestsToApprove(true)}
                style={{ cursor: 'pointer' }}
                color="primary"
                fontWeight={600}
              >
                [Ver pendientes de aprobación]
              </Typography>
            )}
          </div>
        }
        buttons={
          validateCompanyTypes(user, 'FinancingHub') && !businessIdentifierProp
            ? buttonsData
            : [buttonsData[0]]
        }
      />
      {miniLoading && <CenteredCircularProgress type="layout" />}
      <TableWithPagination
        dataHeaders={dataHeaders}
        data={factoringRequests}
        lastElement
        exportToFile="xlsx"
        handleClickRow={handleDetails}
        setData={setFactoringRequests}
        pagination={pagination}
        setPagination={setPagination}
        loading={loading}
        setLoading={setLoading}
        searchData={getFactoringRequests}
        finalSumRow
      />
      {openShoppingCart && (
        <ShoppingDialogRecieved
          shoppingCartType={shoppingCartType}
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          selectedRequest={openRequest}
          setSelectedRequest={setOpenRequest}
          setUp={setUp}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setBackwards={setBackwards}
          resetShoppingCart={resetShoppingCart}
          resetRequestToOriginal={resetRequestToOriginal}
          selectedId={selectedId}
        />
      )}
      {openDocumentsSelector && (
        <DocumentSelector
          open={openDocumentsSelector}
          setOpen={setOpenDocumentsSelector}
          setSelectedDocuments={setSelectedDocuments}
          selectedDocuments={selectedDocuments}
          setNewOpenShoppingCart={setNewOpenShoppingCart}
          business={business}
          setBusiness={setBusiness}
          setSubProductSelected={setSubProductSelected}
          subProductSelected={subProductSelected}
          setSubProduct={setSubProduct}
          backwards={backwards}
          setBackwards={setBackwards}
          setSuccessOpen={setSuccessOpen}
        />
      )}
      {openNewShoppingCart && (
        <ShoppingCartFactoring
          business={business}
          setBackwards={setBackwards}
          backwards={backwards}
          selectedDocuments={selectedDocuments}
          setSelectedDocuments={setSelectedDocuments}
          setOpenShoppingcart={setNewOpenShoppingCart}
          openShoppingCart={openNewShoppingCart}
          setSuccess={setSuccess}
          setFailed={setFailed}
          exchangeDay={exchangeDay}
          setExchangeDay={setExchangeDay}
          setSuccesText={setSuccesText}
          setFailedText={setFailedText}
          setContinueToSimulation={handleToSimulation}
          setSelectedRequest={setSelectedRequest}
          subProductSelected={subProductSelected}
          subProduct={subProduct}
          setOpenDocumentsSelector={setOpenDocumentsSelector}
          operationDate={operationDate}
          setOperationDate={setOperationDate}
        />
      )}
      {continueToSimulation && (
        <ShoppingDialogRecieved
          setBackwards={setBackwards}
          backwards={backwards}
          openShoppingCart={continueToSimulation}
          setOpenShoppingCart={setContinueToSimulation}
          openDatesSelection={openNewShoppingCart}
          setOpenDatesSelection={setNewOpenShoppingCart}
          setSelectedDocuments={setSelectedDocuments}
          selectedRequest={selectedRequest}
          setSelectedRequest={setSelectedRequest}
          newRequest
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setUp={setUp}
          executiveCreating
          shoppingCartType="Revisada"
          businessId={business.id}
          subProduct={subProduct}
          setSubProduct={setSubProduct}
          resetShoppingCart={resetShoppingCart}
        />
      )}
      <MyRequestsToApprove
        open={openMyRequestsToApprove}
        onClose={() => setOpenMyRequestsToApprove(false)}
        handleDetails={handleDetails}
      />
      <CustomAlert
        setOpen={setSuccess}
        open={success}
        title="Exito"
        text={successText}
        severity="success"
      />
      <CustomAlert
        setOpen={setFailed}
        open={failed}
        title="Oops"
        text={failedMessage}
        severity="error"
      />
    </div>
  );
};

export default FactoringRequestsRecieved;
